const A = 'A'.charCodeAt(0);
const Z = 'Z'.charCodeAt(0);
const alphabetSize = Z - A + 1;

export const getUpperAlphaIndex = i => {
  const digits = [];
  let number = i - 1;

  while (number >= 0) {
    digits.unshift(String.fromCharCode(A + (number % alphabetSize)));
    number = Math.floor(number / alphabetSize) - 1;
  }

  return digits.join('');
};

export const clamp = (lowerBound, value, upperBound) => (
  Math.min(upperBound, Math.max(lowerBound, value))
);
